<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->

<div class="info-box">
  <div class="info-box__details">{{ office.description }}</div>
</div>
